module.exports = __webpack_public_path__ + "img/UpdatedLandingcomLogo1.3f8430bc.png";